import { useTranslation } from 'react-i18next';
import { type StandardApplicationModuleSpecsFragment } from '../../../../api/fragments/StandardApplicationModuleSpecs';
import ApplicationModuleVehicleAssignments from '../shared/ApplicationModuleVehicleAssignments';

export type UpdateVehicleAssignmentsValue = {
    dealerVehicles: Record<string, string[]>;
};

export type VehicleAssignmentsProps = {
    module: StandardApplicationModuleSpecsFragment;
};

const VehicleAssignments = ({ module }: VehicleAssignmentsProps) => {
    const { t } = useTranslation(['eventApplicationModuleDetails']);

    return (
        <ApplicationModuleVehicleAssignments
            module={module}
            noItemText={t('eventApplicationModuleDetails:tabs.vehicles.noData')}
        />
    );
};

export default VehicleAssignments;
